<template>
  <b-row class="mb-32">
    <!-- <b-col cols="12" class="mb-32">
      <b-row align-v="center" align-h="between">
      </b-row>
    </b-col> -->

    <b-col cols="12">
      <b-row>
        <b-col cols="12" md="6" xl="6" class="mb-32">
          <!-- <customer-feature-card /> -->
          <router-link :to="{ name: 'ListManagerVehicle' }" class="text-decoration-none">
          <b-card class="dashboard-card">
              <b-row>
                <b-col class="hp-flex-none w-auto">
                  <b-avatar class="bg-success hp-bg-color-dark-success" size="48px">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor"
                        viewBox="0 0 16 16" class="bi bi-car-front-fill" style="color: white;">
                        <path d="M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679c.033.161.049.325.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.807.807 0 0 0 .381-.404l.792-1.848ZM3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2H6ZM2.906 5.189a.51.51 0 0 0 .497.731c.91-.073 3.35-.17 4.597-.17 1.247 0 3.688.097 4.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 11.691 3H4.309a.5.5 0 0 0-.447.276L2.906 5.19Z"/>
                      </svg>
                    </i>
                  </b-avatar>
                </b-col>

                <b-col class="pl-0">
                <h3 class="mb-4 mt-8">
                  {{ total_vehicles }}
                </h3>

                <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">
                  Total Vehicle
                </p>
                 </b-col>
                </b-row>
            </b-card>
          </router-link>
        </b-col>

        <b-col cols="12" md="6" xl="6" class="mb-32">
          <router-link :to="{ name: 'ListMarketPlaceManager' }" class="text-decoration-none">
          <b-card class="dashboard-card">
              <b-row>
                <b-col class="hp-flex-none w-auto">
                  <b-avatar class="bg-primary hp-bg-color-dark-primary" size="48px">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor"
                        viewBox="0 0 16 16" class="bi bi-shop" style="color: white;">
                        <path d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.371 2.371 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976L2.97 1.35zM1.5 5.625c0 .76.616 1.375 1.375 1.375S4.25 6.385 4.25 5.625 3.634 4.25 2.875 4.25 1.5 4.865 1.5 5.625zM15 5.625c0 .76-.616 1.375-1.375 1.375S12.25 6.385 12.25 5.625s.616-1.375 1.375-1.375S15 4.865 15 5.625zM7.25 5.625c0 .76-.616 1.375-1.375 1.375S4.5 6.385 4.5 5.625 5.116 4.25 5.875 4.25s1.375.615 1.375 1.375zM9.125 4.25c-.76 0-1.375.615-1.375 1.375s.616 1.375 1.375 1.375 1.375-.615 1.375-1.375S9.885 4.25 9.125 4.25z"/>
                        <path d="M2 7.625V15a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7.625c-.533.32-1.17.5-1.875.5a3.12 3.12 0 0 1-2.625-1.417 3.12 3.12 0 0 1-2.625 1.417c-.705 0-1.342-.18-1.875-.5z"/>
                      </svg>
                    </i>
                  </b-avatar>
                </b-col>

                <b-col class="pl-0">
                <h3 class="mb-4 mt-8">
                  {{ total_market_place }}
                </h3>

                <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">
                  Total MarketPlace Vehicles
                </p>
                 </b-col>
                </b-row>
            </b-card>
          </router-link>
        </b-col>
            <b-col cols="12" md="6" xl="6" class="mb-32">
          <router-link :to="{ name: 'ListManagerVehicle' }" class="text-decoration-none">
          <b-card class="dashboard-card">
              <b-row>
                <b-col class="hp-flex-none w-auto">
                  <b-avatar class="bg-danger hp-bg-color-dark-danger" size="48px">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor"
                        viewBox="0 0 16 16" class="bi bi-exclamation-triangle-fill" style="color: white;">
                        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                      </svg>
                    </i>
                  </b-avatar>
                </b-col>

                <b-col class="pl-0">
                <h3 class="mb-4 mt-8">
                  {{ totalTheftVehicles }}
                </h3>

                <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">
                  Total Theft Vehicles
                </p>
                 </b-col>
                </b-row>
            </b-card>
          </router-link>
        </b-col>
        
        <b-col cols="12" md="6" xl="6" class="mb-32">
          <router-link :to="{ name: 'ListManagerVehicle' }" class="text-decoration-none">
          <b-card class="dashboard-card">
              <b-row>
                <b-col class="hp-flex-none w-auto">
                  <b-avatar class="bg-info hp-bg-color-dark-info" size="48px">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor"
                        viewBox="0 0 16 16" class="bi bi-arrow-clockwise" style="color: white;">
                        <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                      </svg>
                    </i>
                  </b-avatar>
                </b-col>

                <b-col class="pl-0">
                <h3 class="mb-4 mt-8">
                  {{ totalRecoverVehicles }}
                </h3>
                <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">
                  Total Recover Vehicles
                </p>
                 </b-col>
                </b-row>
            </b-card>
          </router-link>
        </b-col>
        <!-- .... -->

        <b-col cols="12" xl="12">
          <b-row>
            <b-col cols="12" class="mb-32">
              <revenue-column-card />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BCard ,BAvatar} from "bootstrap-vue";
import axios from "axios";
import CustomerFeatureCard from "../../widgets/cards/advance/CustomerFeatureCard.vue";
import OrdersFeatureCard from "../../widgets/cards/advance/OrdersFeatureCard.vue";
import SaleFeatureCard from "../../widgets/cards/advance/SaleFeatureCard.vue";
import ProfitFeatureCard from "../../widgets/cards/advance/ProfitFeatureCard.vue";
import RevenueColumnCard from "../../widgets/cards/analytics/RevenueColumnCard.vue";
import CtaCardTwo from "../../widgets/cards/advance/CtaCardTwo.vue";
import RevenueCard from "../../widgets/cards/statistics/RevenueCard.vue";
import BrowserStates from "./BrowserStates.vue";
import EarningsCard from "./EarningsCard.vue";
import LatestOrders from "./LatestOrders.vue";
import CheckDetailCard from "./CheckDetailCard.vue";
import BestSellingProducts from "./BestSellingProducts.vue";

export default {
  data() {
    return {
      totalTheftVehicles: 0,
      totalRecoverVehicles: 0,
      total_market_place: 0,
      total_vehicles: 0,
    };
  },
  components: {
    BRow,
    BCol,
    BCard,
    BAvatar,
    CustomerFeatureCard,
    OrdersFeatureCard,
    SaleFeatureCard,
    ProfitFeatureCard,
    RevenueColumnCard,
    CtaCardTwo,
    RevenueCard,
    BrowserStates,
    EarningsCard,
    LatestOrders,
    CheckDetailCard,
    BestSellingProducts,
  },
  mounted() {
    this.getDashboardDataManager();
  },
  methods: {
    async getDashboardDataManager() {
      try {
          this.managerId = localStorage.getItem("userId");
        const response = await axios.get("/dashboardManger/"+ this.managerId);
        if (response.data.success) {
          this.totalTheftVehicles = response.data.data.total_theft_vehicles;
          this.totalRecoverVehicles = response.data.data.total_recover_vehicles;
          this.total_vehicles = response.data.data.total_vehicles;
          this.total_market_place = response.data.data.total_market_place;
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    },
  },
};
</script>
<style scoped>
.dashboard-card {
  transition: all 0.3s ease-in-out;
  border-radius: 16px;
}

.dashboard-card:hover {
  transform: translateY(-6px) scale(1.03);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  cursor: pointer;
}

.dashboard-card h3,
.dashboard-card p {
  transition: color 0.3s ease-in-out;
}

.dashboard-card:hover h3 {
  color: #2f855a; /* Slight highlight on hover */
}
</style>